import HomeForm from './home/HomeForm';
import AboutForm from './about/AboutForm';
import ContactsForm from './contacts/ContactsForm';
import FormNews from './notice/index';
import ServicesForm from './services/ServicesForm';
import GeneralForm from './general/GeneralForm';

export {
  HomeForm,
  AboutForm,
  ContactsForm,
  FormNews,
  ServicesForm,
  GeneralForm
};



// WEBPACK FOOTER //
// ./src/forms/index.js